export const ProductionText = () => {}
